import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useRef } from 'react';

const Embarcaciones = ({ lang, destino, barcos, ruta }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 16;

    const listRef = useRef(null);

    useEffect(() => {
        setCurrentPage(1);
    }, [barcos]);

    const totalPages = Math.ceil(barcos.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentBarcos = barcos.slice(startIndex, endIndex);

    const scrollToTop = () => {
        if (listRef.current) {
            listRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
            scrollToTop();
        }
    }

    const goToPrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
            scrollToTop();
        }
    }

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            scrollToTop();
        }
    }


    return (
        <>
            <section className="u-clearfix u-custom-color-11 u-section-1" id="block-14" ref={listRef}>
                <div className="u-clearfix u-sheet u-sheet-1">
                    <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-0"> {destino.elnombre.toUpperCase()}</h1>
                </div>
            </section>

            <section className="u-align-center u-clearfix u-container-align-center u-section-1" id="block-13">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <div className="u-expanded-width u-layout-grid u-list u-list-1">
                        <div className="u-repeater u-repeater-1">
                            {
                                currentBarcos.map((unbarco, indexb) => (
                                    <div className="u-align-center u-container-align-center u-container-style u-list-item u-repeater-item" key={"barco-" + indexb}>
                                        <div className="u-container-layout u-similar-container u-container-layout-1">
                                            {
                                                (unbarco.foto_principal && unbarco.foto_principal.length > 0) ?
                                                    <img className="u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="2062" data-image-height="1374" src={ruta + "/propiedades/" + unbarco.id + "/fotos/web/" + unbarco.foto_principal[0].nombre} />
                                                    :
                                                    <img className="u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="2062" data-image-height="1374" src="/images/web/onboard2/00-ONBOARDLOGO-HORIZONTAL-TR_TRANSP-2025.png" />
                                            }

                                            <i className="fa-solid fa-ruler-triangle"></i> {unbarco['metros_cuadrados']}m | <i className="fa-solid fa-bed"></i> {unbarco['num_habitaciones']} | <i className="fa-solid fa-users"></i> {unbarco.capacidad_maxima}
                                            <h4 className="u-text u-text-1">
                                                <a href={"/" + preidioma + t("embarcaciones") + "-" + unbarco.destino.url_dinamica[lang] + "/" + unbarco.url_dinamica} className="u-active-none u-border-none u-btn u-button-style u-hover-none u-none u-text-palette-1-base u-btn-5">{unbarco.nombre}<br />
                                                </a>
                                            </h4>
                                            <p className="u-align-center u-text u-text-grey-50 u-text-2">{unbarco.nombre_ruta}<br />
                                            </p>
                                            <a href={"mailto:info@onboardholidays.com?subject=Quiero%20solicitar%20disponibilidad%20para%20" + unbarco.nombre} className="u-align-center u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-1-base u-radius u-btn-2">{t("Solicitar")} </a>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>

            <section className="u-clearfix u-section-7" id="block-16">
                {totalPages > 1 && (
                    <div className="u-clearfix u-sheet u-sheet-1 u-flex-row u-flex-wrap u-margin-top-20 u-pagination-container">
                        {currentPage > 1 && (
                            <button
                                className="u-btn u-button-style u-radius u-btn-2"
                                onClick={goToPrevPage}
                            >
                                {t("<<")}
                            </button>
                        )}

                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index + 1}
                                className={`u-btn u-button-style u-radius u-btn-2 ${currentPage === index + 1 ? 'u-active-palette-1-base' : ''}`}
                                onClick={() => goToPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}

                        {currentPage < totalPages && (
                            <button
                                className="u-btn u-button-style u-radius u-btn-2"
                                onClick={goToNextPage}
                                disabled={currentPage === totalPages}
                                style={{ opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                            >
                                {">>"}
                            </button>
                        )}
                    </div>
                )}
            </section >

            <section className="u-clearfix u-section-6" id="block-11">
                <div className="u-clearfix u-sheet u-sheet-1"></div>
            </section>
            <section className="u-clearfix u-section-7" id="block-16">
                <div className="u-clearfix u-sheet u-sheet-1">
                </div>
            </section>
        </>
    );
}

export default Embarcaciones;

